module.exports = __webpack_public_path__ + "static/media/8.a7498c49.png";